<div class="pb-2">
    <input *ngIf="to.type !=='number' else numberTmp" [type]="to.type || 'text'" [formControl]="formControl"
        kendoTextBox [formlyAttributes]="field" [class.k-state-invalid]="showError" [class]="to.className" />
    <ng-template #numberTmp>
        <input type="number" [formControl]="formControl" [formlyAttributes]="field" kendoTextBox
            [class.k-state-invalid]="showError" [class]="to.className" />
        <!--kendo-numerictextbox doesn't allow placeholder therefore keep the input for now.
    <kendo-numerictextbox [format]="'n0'" [min]="to.min" [max]="to.max" [formControl]="formControl"
        [formlyAttributes]="field" [class.k-state-invalid]="showError" [class]="to.className">
    </kendo-numerictextbox>-->
    </ng-template>
    <small *ngIf="to.description" class="form-text text-muted">{{ to.description }}</small>
</div>